import { createStore } from '@/lib/store'

export type ToastTone = 'success' | 'error' | 'info'

export interface ToastItem {
  id: number
  tone: ToastTone
  message: string
}

export const toasts = createStore<ToastItem[]>([])
let nextId = 1

export function toast(message: string, tone: ToastTone = 'info') {
  const id = nextId++
  toasts.set((list) => [...list.slice(-2), { id, tone, message }])
  setTimeout(() => dismissToast(id), tone === 'error' ? 6000 : 3500)
}

export function dismissToast(id: number) {
  toasts.set((list) => list.filter((t) => t.id !== id))
}
